














import { Component, Vue, Prop } from "vue-property-decorator";
import {
  CircleStyle,
  CustomColor
} from "@/typescript/components/common/figures/circle_component/types";
export { CircleStyle, CustomColor };

@Component
export default class CircleComponent extends Vue {
  @Prop({
    default: 0
  })
  color!: number;

  @Prop({
    default: "50px"
  })
  size!: string;

  @Prop({
    default: ""
  })
  warningImage!: string;

  @Prop({
    default: ""
  })
  categoryImage!: string;

  @Prop()
  customColor!: CustomColor;

  get style(): CircleStyle {
    const circleStyle: CircleStyle = {
      width: this.size,
      height: this.size
    };
    if (!this.customColor) return circleStyle;
    circleStyle.background = this.customColor.background;
    circleStyle.border = this.customColor.border;
    return circleStyle;
  }
}
